import React from 'react';

const LiveStatsLoader = () => {
  return (
    <div className="live-stats-loader">
      <div className="loader-content">
        <div className="spinner"></div>
        <p>Loading live tournament data...</p>
      </div>
    </div>
  );
};

export default LiveStatsLoader;
